const comments = [
  {
    name: '光影追梦人',
    time: '2天前',
    content: '从大学就开始用大师兄影视了，更新速度真的没得说！每次有新片上映，这里总是最先能看到的。画质也很稳定，基本没遇到过卡顿的情况，强烈推荐给所有爱看电影的朋友。',
    likes: '1.2k',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20profile%20portrait%20with%20warm%20cinematic%20lighting%2C%20friendly%20expression%2C%20clean%20background%20with%20soft%20amber%20tones%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-dsxy-01&orientation=squarish',
  },
  {
    name: '周末刷剧人',
    time: '3天前',
    content: '作为一名追剧狂魔，大师兄影视简直就是我的快乐源泉！剧集更新和电视台几乎同步，综艺也是当晚就能看回放。最赞的是完全免费不用注册，这在现在的环境下太难得了。',
    likes: '986',
    avatar: 'https://readdy.ai/api/search-image?query=Casual%20portrait%20with%20relaxed%20expression%2C%20warm%20natural%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20and%20approachable%20vibe%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-dsxy-02&orientation=squarish',
  },
  {
    name: '电影发烧友老张',
    time: '5天前',
    content: '片库真的全，很多冷门老片在这里都能找到。作为一个老影迷，最感动的是能看到高清修复版的经典港片，那种感觉太奇妙了。希望大师兄影视越做越好，会一直支持的！',
    likes: '754',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20professional%20portrait%20with%20thoughtful%20expression%2C%20warm%20subtle%20lighting%2C%20clean%20dark%20background%2C%20cinematic%20headshot%20style%2C%20friendly%20and%20wise%20look&width=100&height=100&seq=avatar-dsxy-03&orientation=squarish',
  },
  {
    name: '小橙子爱看片',
    time: '1周前',
    content: '手机端的体验太好了，通勤路上就能追剧。离线缓存功能拯救了我的地铁时光，再也不用担心信号不好看不了了。UI设计也很清爽，找片很方便。',
    likes: '632',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20friendly%20portrait%20with%20bright%20smile%2C%20warm%20natural%20lighting%2C%20clean%20soft%20background%2C%20modern%20casual%20style%2C%20approachable%20headshot&width=100&height=100&seq=avatar-dsxy-04&orientation=squarish',
  },
  {
    name: '纪录片爱好者',
    time: '1周前',
    content: '纪录片区真的太棒了！BBC、Discovery的纪录片基本都有中配版，还有大量国产优秀纪录片。对于一个纪录片迷来说，这里简直就是宝藏。更新也很快，新片基本一周内就能看到。',
    likes: '518',
    avatar: 'https://readdy.ai/api/search-image?query=Intellectual%20portrait%20with%20gentle%20expression%2C%20warm%20ambient%20lighting%2C%20clean%20minimal%20background%2C%20scholarly%20vibe%2C%20friendly%20professional%20headshot%20style&width=100&height=100&seq=avatar-dsxy-05&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">
            观众点评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            来自真实观众的观影体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/60"
            >
              {/* Header */}
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-900 whitespace-nowrap">
                    {comment.name}
                  </div>
                  <div className="text-[11px] text-foreground-400">{comment.time}</div>
                </div>
                <div className="flex text-accent-500">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs"></i>
                  ))}
                </div>
              </div>

              {/* Content */}
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {comment.content}
              </p>

              {/* Footer */}
              <div className="flex items-center gap-4 text-[11px] text-foreground-400 pt-3 border-t border-background-200/40">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes}
                </span>
                <span className="cursor-pointer hover:text-foreground-600 transition-colors">回复</span>
                <span className="cursor-pointer hover:text-foreground-600 transition-colors">分享</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}